"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query GetUsers {\n    getUsers(organisationId: \"", "\", role: \"", "\") {\n      userId\n      firstName\n      lastName\n      email\n      jobTitle\n      updatedAt\n      role\n      phoneNumber\n    }\n  }  \n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var SHOOTSTA_ORG_ID = 'f4e7f2c7-7911-4ca9-84f0-4b3ca37249bd';
var SHOOTSTA_EDITOR_ROLE = 'SHOOTSTA_EDITOR';
var getEditorsQuery = (0, _graphqlTag.default)(_templateObject(), SHOOTSTA_ORG_ID, SHOOTSTA_EDITOR_ROLE);
var getEditors = {
  query: getEditorsQuery,
  module: 'users',
  ignoreCache: true,
  buildVariables: function buildVariables() {}
};
var _default = getEditors;
exports.default = _default;